import { DimensionUnit, WeightBasis } from '@freight-cbm/shared-types';
import { convertToCm, convertToInches } from './units';

export function calcDIMWeight(
  length: number,
  width: number,
  height: number,
  dimUnit: DimensionUnit,
  quantity: number,
  divisor: number,
): number {
  if (divisor <= 0) return NaN;

  let dimWeightPerPieceKg: number;

  if (divisor >= 1000) {
    // Metric path: divisor is in cm³/kg
    const l = convertToCm(length, dimUnit);
    const w = convertToCm(width, dimUnit);
    const h = convertToCm(height, dimUnit);
    if (isNaN(l) || isNaN(w) || isNaN(h)) return NaN;
    const volumeCm3 = l * w * h;
    dimWeightPerPieceKg = volumeCm3 / divisor;
  } else {
    // Imperial path: divisor is in in³/lb
    const l = convertToInches(length, dimUnit);
    const w = convertToInches(width, dimUnit);
    const h = convertToInches(height, dimUnit);
    if (isNaN(l) || isNaN(w) || isNaN(h)) return NaN;
    const volumeIn3 = l * w * h;
    const dimWeightPerPieceLb = volumeIn3 / divisor;
    dimWeightPerPieceKg = dimWeightPerPieceLb * 0.45359237;
  }

  return dimWeightPerPieceKg * quantity;
}

export function calcChargeableWeight(
  actualWeightKg: number,
  dimWeightKg: number,
): { chargeableWeightKg: number; weightBasis: WeightBasis } {
  const epsilon = 0.001;
  const chargeableWeightKg = Math.max(actualWeightKg, dimWeightKg);

  let weightBasis: WeightBasis;
  if (Math.abs(actualWeightKg - dimWeightKg) < epsilon) {
    weightBasis = WeightBasis.Equal;
  } else if (actualWeightKg > dimWeightKg) {
    weightBasis = WeightBasis.Actual;
  } else {
    weightBasis = WeightBasis.Dimensional;
  }

  return { chargeableWeightKg, weightBasis };
}

export function reverseDivisor(
  dimWeightKg: number,
  length: number,
  width: number,
  height: number,
  dimUnit: DimensionUnit,
  quantity = 1,
): number {
  if (dimWeightKg <= 0) return NaN;
  const l = convertToCm(length, dimUnit);
  const w = convertToCm(width, dimUnit);
  const h = convertToCm(height, dimUnit);
  if (isNaN(l) || isNaN(w) || isNaN(h)) return NaN;
  const volumeCm3 = l * w * h * quantity;
  return volumeCm3 / dimWeightKg;
}
